import { httpClient } from '../http/httpClient'
import { PartnerType } from '@/app/utils/partners.enum'

export interface SelectOfferPayload {
  produtoId: number
  convenioId: number
  tabelaJurosId: number
  renda: number
  valor: number
  tipoCalculo: 0 | 1
}

export async function selectOffer(id: string, payload: SelectOfferPayload) {
  const { data } = await httpClient.patch(`/crefaz/${id}/selectOffer`, payload, {
    journey: PartnerType.CREFAZ,
  })
  return data
}
